
import {
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
} from '@ionic/vue';
import { defineComponent, onMounted, PropType, ref, Ref, toRef } from "vue";
import AutoFillSelect from '@/components/AutoFillSelect.vue';
import axiosInstance from "@/axiosInstance";
import frTranslations from '@/locales/fr.json';

export default defineComponent({
  name: "BeefCattleDataForm",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    AutoFillSelect
  },
  props: {
    companyId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const currentLanguage = ref('fr');
    const translations = {
      fr: frTranslations,
    };
    const dataLoaded = ref(false);
    const companyId = toRef(props, 'companyId');
    const data = ref({});
    const breedTypes = ref([]);
    const selectedBreedType = ref<any>({});
    const animalTypes = ref([]);
    const selectedAnimalType = ref<any>({});

    const submitForm = async () => {
      try {
        data.value = await updateData(companyId, data.value);
        dataLoaded.value = true;
      } catch (error) {
        console.error('Error updating beef cattle data:', error);
      }
    };

    onMounted(async () => {
      data.value = await getData(companyId);
      breedTypes.value = await getBreedTypes();
      animalTypes.value = await getAnimalTypes();
      dataLoaded.value = true;
    });

    const getBreedTypes = async () => {
      try {
        const response = await axiosInstance.get(`api/core/beef-cattle-breeds/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const getAnimalTypes = async () => {
      try {
        const response = await axiosInstance.get(`api/core/beef-cattle-animal-types/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const getData = async (companyId: Ref<number>) => {
      try {
        const response = await axiosInstance.get(`api/core/beef-cattle-data/${companyId.value}/`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const updateData = async (companyId: Ref<number>, data: any) => {
      try {
        const response = await axiosInstance.put(`api/core/beef-cattle-data/${companyId.value}/update/`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const handleSelected = (option: any, item: any, field: string, update = false) => {
      item[field] = option ? option.id : null;
      if (field == 'breeding_type') {
        selectedBreedType.value = option;
      }
      if (field == 'animal_type') {
        selectedAnimalType.value = option;
      }
      if (update) {
        updateData(companyId, item);
      }
    }


    return {
      translations,
      currentLanguage,
      data,
      breedTypes,
      selectedBreedType,
      animalTypes,
      selectedAnimalType,
      submitForm,
      handleSelected
    };
  },
});
